// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "label[data-v-f30072ba]{color:var(--stan-primary-dark-color);font-size:14px}", "",{"version":3,"sources":["webpack://src/components/modals/RenameModuleModal.vue"],"names":[],"mappings":"AAAA,uBAAuB,oCAAoC,CAAC,cAAc","sourcesContent":["label[data-v-f30072ba]{color:var(--stan-primary-dark-color);font-size:14px}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
